export default __webpack_public_path__ + "static/media/van.53b76da4.png";